import React from "react";
import { Avatar, AvatarProps } from "@pushpress/shared-components";
import { getInitials } from "../../../utils/misc";

interface UserAvatarProps extends AvatarProps {
  data?: {
    firstName?: string | null;
    lastName?: string | null;
    primaryImage?: string | null;
  } | null;
}

function UserAvatar(props: UserAvatarProps) {
  const { data, ...other } = props;

  const { firstName, lastName, primaryImage } = data || {};

  return (
    <Avatar {...other}>
      {primaryImage ? (
        <img src={primaryImage} alt={`${firstName} ${lastName} profile`} />
      ) : (
        getInitials(firstName, lastName).toUpperCase()
      )}
    </Avatar>
  );
}

export default UserAvatar;
